import React, {useState, useEffect} from 'react';
import { Rate } from 'antd-mobile';

import './index.less';

export default function (props) {
  const [txt, setTxt] = useState('');

  useEffect(() => {
    mapTxt(props.value);
  }, []);

  const onChange = e => {
    mapTxt(e);
    props.onChange(e);
  };

  function mapTxt(rating) {
    const {rateText=[]} = props;
    switch(rating) {
      case 1:
        setTxt(rateText[0] || '');
        break;
      case 2:
        setTxt(rateText[1] || rateText[0] || '');
        break;
      case 3:
        setTxt(rateText[2] || rateText[1] || rateText[0] || '');
        break;
      case 4:
        setTxt(rateText[3] || rateText[2] || rateText[1] || rateText[0] || '');
        break;
      case 5:
        setTxt(rateText[4] || rateText[3] || rateText[2] || rateText[1] || rateText[0] || '');
        break;
      default:
        setTxt('');
    }
  }

  return (
    <section className='gst-rate'>
      <Rate 
        count={5}
        allowClear={false}
        readOnly={props.readOnly}
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={e => onChange(e)}
        style={{
          '--star-size': props.size || '20px',
          '--active-color':  props.color || '#ECC083',
        }}
      >
      </Rate>
      {txt ? <span className="gst-rate-status">{txt}</span> : ''}
    </section>
  );
}
